// ---------------------------------------------------------------------------
// DnD Email Editor V2 – HTML pretty-printer
//
// Mirrors the formatter used by the production FTP HTML editor (FtpCodeSync) so
// the html-block code modal indents markup identically. Kept as a standalone,
// dependency-free module so the modal can reuse it without pulling in the whole
// FtpCodeSync component (and its Monaco import).
// ---------------------------------------------------------------------------

const VOID_TAGS = new Set([
  'AREA',
  'BASE',
  'BR',
  'COL',
  'EMBED',
  'HR',
  'IMG',
  'INPUT',
  'LINK',
  'META',
  'PARAM',
  'SOURCE',
  'TRACK',
  'WBR',
]);

/** Re-indent an HTML fragment with two-space nesting. */
export function formatHtmlBlock(html: string): string {
  const exploded = html.replace(/>\s*</g, '>\n<').split('\n');
  const result: string[] = [];
  let depth = 0;
  for (const raw of exploded) {
    const line = raw.trim();
    if (!line) continue;
    if (line.startsWith('</')) {
      depth = Math.max(0, depth - 1);
      result.push(`${'  '.repeat(depth)}${line}`);
    } else if (line.startsWith('<')) {
      const tagMatch = line.match(/^<!/) ? ['', '!'] : line.match(/^<\/?[\w:-]+/i);
      const isDecl = line.startsWith('<!');
      const isSelf =
        isDecl ||
        /\/\s*>$/.test(line) ||
        (tagMatch &&
          !line.startsWith('</') &&
          VOID_TAGS.has((line.match(/^<([\w:-]+)/i)?.[1] ?? '').toUpperCase()));
      result.push(`${'  '.repeat(depth)}${line}`);
      if (!isDecl && !line.startsWith('</') && !isSelf) depth++;
    } else {
      result.push(`${'  '.repeat(depth)}${line}`);
    }
  }
  return result.join('\n');
}
